import { FC, Key } from 'react';
import { ProInput } from '../antd';
import SelectTable from '../SelectTable';
import SearchFormItem from './subpage/searchFormItem';
import SearchFormDisabled from './subpage/disabled';
import { getSelectPlaceholder } from '../utils/ruleUtils';
import { SelectTableProps } from '../SelectTable';
import {
  BaseSearchFormItemProps,
  SearchFormItemEnum,
} from './interface/baseInterface';
import { formatToEnumItem } from '../utils/utils';
import { NodeKey } from '../constants/interface';

export interface SearchFormSelectTableProps extends BaseSearchFormItemProps {
  /** name对应的字段名 */
  namekey?: string;
  /** value对应的字段名 */
  valuekey?: string;
  /** selectTable Props */
  selectTableProps?: SelectTableProps;
}
/** 下拉表格 */
export const SearchFormSelectTable: FC<SearchFormSelectTableProps> = props => {
  const {
    selectTableProps,
    isDetail,
    form,
    render,
    disabledRender,
    isTable,
    name,
    testId,
    label,
    rules,
    ...resProps
  } = props;
  if (!selectTableProps) return null;
  let valueName: NodeKey | undefined = '';
  let labelName: NodeKey | undefined = '';
  if (Array.isArray(name)) {
    valueName = name[0];
    labelName = name[1];
  } else {
    valueName = name;
  }
  const handleBeforeFetch = (params: any) => {
    if (!selectTableProps.beforeFetch) return params;
    return (
      selectTableProps.beforeFetch?.(params, form?.getFieldsValue(true)) ||
      params
    );
  };
  const handleChange = (value: any, item: any, index?: number) => {
    if (selectTableProps.mode === 'multiple') {
      if (labelName)
        form?.setFieldsValue({
          [labelName]: item?.map((v: any) => v[selectTableProps.nameKey]),
        });
    } else {
      if (labelName)
        form?.setFieldsValue({
          [labelName]: item?.[0]?.[selectTableProps.nameKey],
        });
    }
    selectTableProps.onChange?.(value, item, form, index);
  };
  return (
    <>
      <SearchFormItem
        {...resProps}
        name={valueName}
        label={label}
        rules={rules}
      >
        {isDetail || (selectTableProps && selectTableProps.disabled) ? (
          <SearchFormDisabled
            form={form}
            name={valueName}
            options={formatToEnumItem(
              selectTableProps.initOptions,
              selectTableProps.nameKey,
              selectTableProps.valueKey,
            )}
            render={render || disabledRender}
            isTable={isTable}
          />
        ) : (
          <SelectTable
            style={{ width: '100%' }}
            {...selectTableProps}
            placeholder={getSelectPlaceholder(label, selectTableProps, rules)}
            beforeFetch={handleBeforeFetch}
            // @ts-ignore
            onChange={handleChange}
            test-id={`${testId}-${valueName}`}
          />
        )}
      </SearchFormItem>
      {!!labelName && (
        <SearchFormItem
          hidden={true}
          name={labelName}
          style={{ padding: 0, margin: 0 }}
        >
          <ProInput />
        </SearchFormItem>
      )}
    </>
  );
};

SearchFormSelectTable.displayName = SearchFormItemEnum.SearchFormSelectTable;

export default SearchFormSelectTable;
